import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllSoilSolutionAnalysis() {
    const res = API.get(`/soil_solution_analysis/`, configJson);
    return res;
}


export async function getSoilSolutionAnalysisByExploitation(exploitation_id) {
    const res = API.get(`/soil_solution_analysis/exploitation/${exploitation_id}`, configJson);
    return res;
}


export async function getSoilSolutionAnalysisInfo(soilSolutionAnalysis_id) {
    const res = API.get(`/soil_solution_analysis/${soilSolutionAnalysis_id}`, configJson);
    return res;
}


export async function getLastSoilSolutionAnalysis(exploitation_id) {
    const res = API.get(`/soil_solution_analysis/last/${exploitation_id}`, configJson);
    return res;
}


export async function createSoilSolutionAnalysis(data) {
    const res = API.post(`/soil_solution_analysis/`, data, configJson);
    return res;
}


export async function updateSoilSolutionAnalysis(soilSolutionAnalysis_id, data) {
    const res = API.put(`/soil_solution_analysis/${soilSolutionAnalysis_id}/`, data, configJson);
    return res;
}


export async function deleteSoilSolutionAnalysis(soilSolutionAnalysis_id) {
    const res = API.delete(`/soil_solution_analysis/${soilSolutionAnalysis_id}/`, configJson);
    return res;
}
